import Vue from 'vue'
import axios from 'axios'

const state = {
  grupos: [],
  bases: []
}

const mutations = {
  AGREGAR_GRUPO: (state, grupo) => {
    // state.grupos.push(grupo)
    // state.grupos[grupo.id] = grupo
    Vue.set(state.grupos, grupo.id, grupo)
  },
  BORRAR_GRUPO: (state, params) => {
    // state.grupos.splice(params.id, 1)
    Vue.set(state.grupos, params.id, undefined)
  },
  LIMPIAR_GRUPOS: (state) => {
    state.grupos = []
  },
  AGREGAR_BASE: (state, base) => {
    // state.bases.push(base)
    // state.bases[base.id] = base
    Vue.set(state.bases, base.id, base)
  },
  BORRAR_BASE: (state, params) => {
    // state.bases.splice(params.id, 1)
    Vue.set(state.bases, params.id, undefined)
  },
  LIMPIAR_BASES: (state) => {
    state.bases = []
  },
  RENOMBRAR_BASE: (state, params) => {
    Vue.set(state.bases[params.id], 'nombre', params.nombre)
  }
}

const actions = {
  obtenerGrupos(context) {
    context.commit('MOSTRAR_SNACK', { texto: 'Obteniendo grupos' }, { root: true })
    context.commit('LIMPIAR_GRUPOS')
    axios.post('https://api.vlivemedia.com/v1/Grupos/Obtener')
      .then(function (response) {
        if(response.data.data && response.data.data.length) {
          response.data.data.forEach(function (grupo) {
            context.commit('AGREGAR_GRUPO', grupo)
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          console.log("Ningún grupo")
          console.log(response)
        }
      })
  },
  agregarGrupo(context, nombre) {
    context.commit('MOSTRAR_SNACK', {texto: 'Agregando grupo "' + nombre + '"'}, { root: true })
    axios.post('https://api.vlivemedia.com/v1/Grupos/Crear', {nombre: nombre})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('AGREGAR_GRUPO', response.data.data)
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          console.log("Error")
          console.log(response)
        }
      })
  },
  borrarGrupo(context, params) {
    context.commit('MOSTRAR_SNACK', {texto: 'Borrando grupo "' + params.nombre + '"'}, { root: true })
    axios.post('https://api.vlivemedia.com/v1/Grupos/Borrar', {id: params.idG})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('BORRAR_GRUPO', {
            id: params.id
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        }
      })
  },
  obtenerBases(context) {
    context.commit('MOSTRAR_SNACK', { texto: 'Obteniendo bases' }, { root: true })
    context.commit('LIMPIAR_BASES')
    axios.post('https://api.vlivemedia.com/v1/Bases/Obtener')
      .then(function (response) {
        if (response.data.data && response.data.data.length) {
          response.data.data.forEach(function (base) {
            context.commit('AGREGAR_BASE', base)
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          console.log("Ninguna base")
          console.log(response)
        }
      });
  },
  agregarBase(context, params) {
    context.commit('MOSTRAR_SNACK', {texto: 'Agregando base "' + params.nombre + '"'}, {root: true})
    axios.post('https://api.vlivemedia.com/v1/Bases/Crear', {nombre: params.nombre, grupo: params.grupo})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('AGREGAR_BASE', response.data.data)
          context.commit('OCULTAR_SNACK', null, { root: true })
        } else {
          console.log("Error")
          console.log(response)
        }
      })
  },
  borrarBase(context, params) {
    context.commit('MOSTRAR_SNACK', {texto: 'Borrando base "' + params.nombre + '"'}, {root: true})
    axios.post('https://api.vlivemedia.com/v1/Bases/Borrar', {base: params.base})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('BORRAR_BASE', {
            id: params.id
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        }
      })
  },
  renombrarBase(context, params) {
    context.commit('MOSTRAR_SNACK', {texto: 'Renombrando base "' + params.nombre + '"'}, {root: true})
    axios.post('https://api.vlivemedia.com/v1/Bases/Renombrar', {id: params.id, nombre: params.nombre, base: params.base})
      .then(function (response) {
        if (response.data.status === 200) {
          context.commit('RENOMBRAR_BASE', {
            id: params.id,
            nombre: params.nombre
          })
          context.commit('OCULTAR_SNACK', null, { root: true })
        }
      });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}